const TRAILING_PERIODS = /\.+$/;

export const canonicalizeSmsLinkPathname = (pathname: string): string => {
  const segments = pathname.split('/');
  const lastSegmentIndex = segments.length - 1;
  const lastSegment = segments[lastSegmentIndex];

  if (!lastSegment) {
    return pathname;
  }

  const canonicalSegment = lastSegment.replace(TRAILING_PERIODS, '');
  if (!canonicalSegment || canonicalSegment === lastSegment) {
    return pathname;
  }

  segments[lastSegmentIndex] = canonicalSegment;
  return segments.join('/');
};
